import React, { useState, Component, useRef, useEffect } from "react";
import useStyles from "./styles";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import ProductCard from "../../Components/Product-Card/ProductCard";
import Rating from "@material-ui/lab/Rating";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Divider } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useHistory, useLocation, Link } from "react-router-dom";
import api from "../../Axios/api";

//importing files
import { useUserContext } from "../../context/UserContext";
import noImage from "../../assets/images/Product Images/noImage.png";
import loadingImg from "../../assets/images/loadingImg.gif";
import headPhone from "../../assets/images/Product Images/wirelesHeadPhone.jpg";
import {
  useWishlistContext,
  addProductToWishlist,
} from "../../context/WishlistContext";
//Files import
import { useCartContext, addProductToCart } from "../../context/CartContext";

// MUI Components
import {
  Grid,
  Box,
  Button,
  Typography,
  Paper,
  TextField,
  IconButton,
  InputLabel,
} from "@material-ui/core";

import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import DepartureBoardIcon from "@material-ui/icons/DepartureBoard";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import Filter7Icon from "@material-ui/icons/Filter7";
import ForumIcon from "@material-ui/icons/Forum";
import SecurityIcon from "@material-ui/icons/Security";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import Backdrop from "@material-ui/core/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import { Comment, Reply } from "@material-ui/icons";

export default function ProductDetails() {
  const classes = useStyles();
  let token = "";
  let userId = "";
  const { store } = useUserContext();
  if (store.data !== null) {
    token = store.data.token;
    if (store.data.data) userId = store.data.data._id;
  }
  const { dispatch, cartProducts } = useCartContext();
  const { wishlistDispatch, wishlistProducts } = useWishlistContext();

  const [mainProductImage, setMainProductImage] = useState(headPhone);
  const [quantity, setQuantity] = useState(1);
  const search = useLocation().search;
  const selectedProductId = new URLSearchParams(search).get("productId");
  const [productDetails, setProductDetails] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [storeDetails, setStoreDetails] = useState(null);
  const [topSellingProductsOfStore, setTopSellingProductsOfStore] = useState(
    []
  );
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [fourRatingCount, setFourRatingCount] = useState(0);
  const [oneRatingCount, setOneRatingCount] = useState(0);
  const [twoRatingCount, setTwoRatingCount] = useState(0);
  const [threeRatingCount, setThreeRatingCount] = useState(0);
  const [fiveRatingCount, setFiveRatingCount] = useState(0);
  const history = useHistory();
  const ref = useRef(null);
  const refStoreProducts = useRef(null);
  const [openReviewModal, setOpenReviewModal] = React.useState(false);
  const [newReview, setNewReview] = useState({
    productId: "",
    productName: "",
    storeId: "",
    storeName: "",
    comment: "",
    rating: 0,
    pictures: [],
  });
  const [selectedColor, setSelectedColor] = useState(null);
  const [addReviewErrorMsg, setAddReviewErrorMsg] = useState("");
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const handleOpenReviewModal = () => {
    setAddReviewErrorMsg("");
    setOpenReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setOpenReviewModal(false);
  };
  if (!mainProductImage) {
    setMainProductImage(noImage);
  }

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };
  const scrollStoreProducts = (scrollOffset) => {
    refStoreProducts.current.scrollLeft += scrollOffset;
  };

  const reduceQuantity = () => {
    if (quantity >= 2) {
      setQuantity(quantity - 1);
    }
  };
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }
  const changeQuantity = (e) => {
    if (
      isNumeric(e.target.value) &&
      productDetails.stockAvailable >= e.target.value
    )
      setQuantity(parseInt(e.target.value));
  };

  const increaseQuantity = () => {
    if (quantity <= productDetails.stockAvailable - 1) {
      setQuantity(quantity + 1);
    } else {
      showOutOfStockSnackBarError();
    }
  };
  useEffect(() => {
    //scroll to the top of page
    window.scrollTo(0, 0);
    api
      .get(`/buyer/product/${selectedProductId}`, {}, { Headers: {} })
      .then((res) => {
        const data = res.data.data;
        setProductDetails(data.product);
        setRelatedProducts(data.relatedProducts);
        setStoreDetails(data.storeDetails);
        setTopSellingProductsOfStore(data.topSellingProductsOfStore);
        setMainProductImage(
          data.product.images.length > 0 ? data.product.images[0] : noImage
        );
        setIsLoading(false);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );

    api
      .get(`/buyer/reviews/product/${selectedProductId}`, {}, { Headers: {} })
      .then((res) => {
        setReviews(res.data.data.reviews);
        getCountOfEveryRating(res.data.data.reviews);
      })
      .catch((error) =>
        console.log("error in getting data of homepage", error)
      );
  }, [selectedProductId]);

  const getLinkOfProductsByCategory = (category) => {
    return `/products?mainCategoryName=${encodeURIComponent(category)}`;
  };
  const getLinkOfProductsBySubCategory = (subCategory, category) => {
    return `/products?subCategoryName=${encodeURIComponent(
      subCategory
    )}&mainCategoryOfSubCategory=${encodeURIComponent(category)}`;
  };
  const styleForLoadingDiv = {
    display: "flex",
    justifyContent: "center",
    paddingTop: "10%",
    paddingBottom: "14%",
  };
  const getCountOfEveryRating = (reviews) => {
    for (let index = 0; index < reviews.length; index++) {
      const element = reviews[index];
      const rating = Math.floor(element.rating);
      // console.log(rating)
      if (rating === 1) {
        setOneRatingCount(oneRatingCount + 1);
      }
      if (rating === 2) {
        setTwoRatingCount(twoRatingCount + 1);
      }
      if (rating === 3) {
        setThreeRatingCount(threeRatingCount + 1);
      }
      if (rating === 4) {
        setFourRatingCount(fourRatingCount + 1);
      }
      if (rating === 5) {
        setFiveRatingCount(fiveRatingCount + 1);
      }
    }
  };
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlerDeletePImage = (index) => {
    const pImages = newReview.pictures.filter((el, eindex) => eindex !== index);

    setNewReview({
      ...newReview,
      pictures: pImages,
    });
  };

  const fileHandler = async (event) => {
    let prevImages = newReview.pictures;
    let files = event.target.files;
    let temp = [];

    for (let i = 0; i < files.length; i++) {
      var file64 = await toBase64(files[i]);
      temp.push(file64);
    }

    if (prevImages.length > 0) {
      setNewReview({
        ...newReview,
        pictures: [...prevImages, ...temp],
      });
    } else {
      setNewReview({
        ...newReview,
        pictures: temp,
      });
    }
  };

  const handleAddingReview = () => {
    if (!newReview.comment) {
      setAddReviewErrorMsg("Please enter review description !");
      // document.getElementById("reviewDescription").style.borderColor = "red";
      return;
    }
    let temp = {};
    if (productDetails != null) {
      temp = {
        ...newReview,
        productId: productDetails._id,
        productName: productDetails.name,
        storeId: storeDetails._id,
        storeName: storeDetails.name,
      };

      setNewReview(temp);
    }

    api
      .post(
        "/buyer/product/review",
        {
          ...temp,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        if (res.data) {
          handleCloseReviewModal();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Review added successfully!",
            open: true,
          });
          setAddReviewErrorMsg("");
          // document.getElementById("reviewDescription").style.borderColor =
          //   "none";
        }
      })
      .catch((error) =>
        error.response
          ? setSnackBar({
              ...snackBarstate,
              message: JSON.stringify(
                error.response
                  ? error.response.data.error.message
                  : "Please login from account."
              ).replace(/"/g, ""),
              type: "warning",
              open: true,
            })
          : null
      );
  };

  const handleSelectedColor = (color, index) => {
    setSelectedColor(color);
  };

  const showOutOfStockSnackBarError = () => {
    return setSnackBar({
      ...snackBarstate,
      type: "error",
      message: `Sorry! Maximun Stock available is ${
        productDetails ? productDetails.stockAvailable : `less.`
      }`,
      open: true,
    });
  };

  const addItemToCart = () => {
    const temp = cartProducts;
    if (quantity > productDetails.stockAvailable) {
      return showOutOfStockSnackBarError();
    }

    if (productDetails.colors.length > 0 && !selectedColor) {
      if (productDetails.colors.length === 1) {
        setSelectedColor(productDetails.colors[0]);
      } else {
        return setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "Please select any color of product.",
          open: true,
        });
      }
    }
    const cartItem = {
      brand: productDetails.vendorCompanyName,
      category: productDetails.category,
      cutPrice: productDetails.salePrice,
      price: productDetails.discountPrice
        ? productDetails.discountPrice
        : productDetails.salePrice,
      discountPercentage: productDetails.discountPercentage,
      image: Array.isArray(productDetails.images)
        ? productDetails.images.length > 0
          ? productDetails.images[0]
          : noImage
        : productDetails.images
        ? productDetails.images
        : noImage,
      isNew: productDetails.state === "new" ? true : false,
      quantity: quantity,
      rating: productDetails.rating,
      shippingCost: productDetails.shippingCost,
      stockAvailable: productDetails.stockAvailable,
      storeName: storeDetails.name,
      title: productDetails.name,
      totalRatingStars: productDetails.totalRatingStars,
      dimensions: productDetails.dimensions,
      color: selectedColor,
      _id: productDetails._id,
    };
    // console.log("cart Item", cartItem);
    if (cartProducts === "null" || cartProducts === null) {
      if (cartItem.stockAvailable >= 1) {
        window.location.href = "/cart";
        return addProductToCart(dispatch, [cartItem]);
      } else {
        return showOutOfStockSnackBarError();
      }
    } else {
      if (!cartProducts.filter((e) => e._id === cartItem._id).length > 0) {
        if (cartItem.stockAvailable >= 1) {
          let temp = cartProducts;
          temp.push(cartItem);
          window.location.href = "/cart";
          return addProductToCart(dispatch, temp);
        } else {
          return showOutOfStockSnackBarError();
        }
      } else {
        cartProducts.forEach((product) => {
          if (product._id === cartItem._id) {
            if (product.stockAvailable >= product.quantity + 1) {
              if (product.color === cartItem.color) {
                product.quantity += 1;
                window.location.href = "/cart";
              } else {
                let temp = cartProducts;
                temp.push(cartItem);
                window.location.href = "/cart";
                return addProductToCart(dispatch, temp);
              }
            } else {
              return showOutOfStockSnackBarError();
            }
          }
        });
        let temp = cartProducts;
        return addProductToCart(dispatch, temp);
      }
      // console.log("cart Products", cartProducts)
    }
  };

  const addItemToWishlist = () => {
    if (productDetails.colors.length > 0 && !selectedColor) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "Please select any color of product.",
        open: true,
      });
    }
    const wishlistProduct = {
      brand: productDetails.vendorCompanyName,
      category: productDetails.category,
      cutPrice: productDetails.salePrice,
      price: productDetails.discountPrice
        ? productDetails.discountPrice
        : productDetails.salePrice,
      discountPercentage: productDetails.discountPercentage,
      image: Array.isArray(productDetails.images)
        ? productDetails.images.length > 0
          ? productDetails.images[0]
          : noImage
        : productDetails.images
        ? productDetails.images
        : noImage,
      isNew: productDetails.state === "new" ? true : false,
      quantity: quantity,
      rating: productDetails.rating,
      shippingCost: productDetails.shippingCost,
      stockAvailable: productDetails.stockAvailable,
      storeName: storeDetails.name,
      title: productDetails.name,
      totalRatingStars: productDetails.totalRatingStars,
      dimensions: productDetails.dimensions,
      _id: productDetails._id,
      color: selectedColor,
    };
    if (wishlistProducts === "null" || wishlistProducts === null) {
      window.location.reload(false);
      return addProductToWishlist(wishlistDispatch, [wishlistProduct]);
    } else {
      if (
        !wishlistProducts.filter((e) => e._id === wishlistProduct._id).length >
        0
      ) {
        window.location.reload(false);
        let temp = wishlistProducts;
        temp.push(wishlistProduct);
        return addProductToWishlist(wishlistDispatch, temp);
      } else {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "Product already present in wishlist. ",
          open: true,
        });
      }
    }
  };

  return (
    <div style={isLoading ? styleForLoadingDiv : null}>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
      {!isLoading ? (
        <div className={classes.mainProductContainer}>
          <Breadcrumbs
            style={{ paddingTop: 27, paddingBottom: 15 }}
            aria-label="breadcrumb"
          >
            <Link className={classes.bCrumbLink} color="inherit" to="/">
              Home
            </Link>
            <Link
              color="inherit"
              to={getLinkOfProductsByCategory(
                productDetails ? productDetails.category : "All Categories"
              )}
              className={classes.bCrumbLink}
            >
              {productDetails ? productDetails.category : null}
            </Link>
            <Link
              color="inherit"
              to={
                productDetails
                  ? productDetails.subCategory
                    ? getLinkOfProductsBySubCategory(
                        productDetails.subCategory,
                        productDetails.category
                      )
                    : getLinkOfProductsByCategory(
                        productDetails
                          ? productDetails.category
                          : "All Categories"
                      )
                  : null
              }
              className={classes.bCrumbLink}
            >
              {productDetails ? productDetails.subCategory : null}
            </Link>
            <Typography color="textPrimary" noWrap className={classes.bcrumCurrentPageText} >
              {productDetails ? productDetails.name : null}
            </Typography>
          </Breadcrumbs>

          {/* Main Product Container */}
          <Grid
            container
            className={classes.productDescMainGrid}
            lg={12}
            sm={12}
            xs={12}
          >
            <Grid lg={4} sm={12}>
              <img
                className={classes.mainProductImg}
                src={mainProductImage}
                title={productDetails.name}
              />
              <Grid style={{ display: "flex", flexDirection: "row" }}>
                <IconButton
                  onClick={() => scroll(-145)}
                  style={{
                    backgroundColor: "#fff",
                    marginRight: 5,
                    padding: 0,
                  }}
                >
                  <ChevronLeftRoundedIcon />
                </IconButton>
                <Grid ref={ref} className={classes.subCategoryImgBoxGrid}>
                  {productDetails.images.map((item) =>
                    React.cloneElement(
                      <Button
                        className={classes.subcategoryImgBtn}
                        onClick={() => setMainProductImage(item)}
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <img
                          className={classes.subProductImg}
                          src={item ? item : noImage}
                          title={productDetails.name}
                        />
                      </Button>,
                      {
                        key: item.src,
                      }
                    )
                  )}
                </Grid>
                <IconButton
                  onClick={() => scroll(145)}
                  style={{ backgroundColor: "#fff", padding: 0, marginLeft: 3 }}
                >
                  <ChevronRightOutlinedIcon />
                </IconButton>
              </Grid>
            </Grid>

            {/* Product Name and Price Section */}
            <Grid
              style={{
                padding: 15,
                paddingLeft: 25,
                paddingTop: 15,
                paddingRight: 20,
              }}
              lg={5}
            >
              <Typography
                style={{
                  fontWeight: "bold",
                  letterSpacing: 1,
                  textAlign: "justify",
                  overFlow: "hidden",
                  textOverflow: "ellipsis",
                }}
                variant="h4"
              >
                {productDetails.name}
              </Typography>
              <div className={classes.ratingBox} style={{ paddingTop: 0 }}>
                <Rating
                  name="half-rating-read"
                  defaultValue={
                    productDetails.avgRating ? productDetails.avgRating : 0
                  }
                  //className={classes.ratingStars}
                  style={{ fontSize: 15 }}
                  precision={0.5}
                  readOnly
                />
                <Typography
                  style={{ marginLeft: 10, fontSize: 13 }}
                  variant="p"
                >
                  {productDetails.totalRatingStars
                    ? Math.round(productDetails.totalRatingStars)
                    : 0}{" "}
                  Rating(s)
                </Typography>

                <div
                  style={{
                    borderLeft: "0.3px solid silver",
                    height: "19px",
                    marginLeft: 7,
                    marginRight: 7,
                  }}
                ></div>
                <Typography style={{ fontSize: 13 }} variant="p">
                  {reviews.length} Review(s)
                </Typography>
              </div>
              <Divider
                style={{
                  marginTop: 15,
                  marginBottom: 13,
                  backgroundColor: "#e9e9e9",
                  height: "0.1px",
                }}
              />

              <div className={classes.pricesBox} style={{ display: "flex" }}>
                <Typography
                  className={classes.priceText}
                  gutterBottom
                  style={{ marginRight: 14 }}
                  variant="h3"
                  component="p"
                >
                  Rs.{" "}
                  {productDetails.discountPrice
                    ? productDetails.discountPrice
                    : productDetails.salePrice}
                </Typography>
                <div style={{ display: "flex" }}>
                  <Typography
                    className={classes.cutPriceText}
                    variant="h5"
                    style={{ color: "grey" }}
                    component="p"
                  >
                    {productDetails.discountPrice
                      ? `Rs. ${productDetails.salePrice}`
                      : null}
                  </Typography>

                  <Typography
                    variant="p"
                    style={{ marginLeft: 7, marginTop: 3, fontWeight: "bold" }}
                  >
                    {productDetails.discountPercentage
                      ? `-${productDetails.discountPercentage}%`
                      : null}
                  </Typography>
                </div>
              </div>
              <Divider
                style={{
                  marginTop: 20,
                  marginBottom: 22,
                  backgroundColor: "#e9e9e9",
                  height: "0.1px",
                }}
              />
              {productDetails.colors ? (
                <div className={classes.colorPickerMainBox}>
                  <Typography
                    variant="p"
                    style={{
                      fontWeight: "bold",
                      marginTop: 5,
                      marginRight: 33,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Colors
                  </Typography>
                  {productDetails.colors.length > 0 ? (
                    productDetails.colors.map((color, index) =>
                      React.cloneElement(
                        <Button
                          className={classes.colorBox}
                          style={{
                            backgroundColor: color,
                            height: 32,
                            minWidth: 32,
                          }}
                          onClick={() => handleSelectedColor(color, index)}
                        ></Button>,
                        {
                          key: index,
                        }
                      )
                    )
                  ) : (
                    <span style={{ color: "grey" }}>Default</span>
                  )}
                  <Typography
                    variant="p"
                    style={{ textAlign: "center", display: "flex", margin: 4 }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#666",
                        marginLeft: 3,
                      }}
                    >
                      {selectedColor}
                    </span>
                  </Typography>
                </div>
              ) : null}
              {productDetails.dimensions ? (
                <div
                  className={classes.colorPickerMainBox}
                  style={{
                    marginTop: 20,
                    display: "flex",
                    alignItems: "center",
                    marginTop: 25,
                  }}
                >
                  <Typography
                    variant="p"
                    style={{
                      fontWeight: "bold",
                      marginTop: 4,
                      marginRight: 10,
                    }}
                  >
                    Product State
                  </Typography>
                  <Typography
                    className={classes.colorBox}
                    style={{
                      height: 32,
                      minWidth: 32,
                      borderRadius: 0,
                      padding: 5,
                      display: "flex",
                      textAlign: "center",
                    }}
                  >
                    {productDetails.state ? productDetails.state : "New"}
                  </Typography>
                </div>
              ) : null}
              <div
                className={classes.counterBox}
                style={{ display: "flex", flexDirection: "row", marginTop: 25 }}
              >
                <Typography
                  variant="p"
                  style={{
                    fontWeight: "bold",
                    marginTop: 5,
                    marginRight: 19.6,
                  }}
                  component="p"
                >
                  Quantity
                </Typography>
                <Button
                  style={{
                    height: 32,
                    fontSize: 20,
                    minWidth: 32,
                    border: "0.2px solid silver",
                  }}
                  onClick={() => reduceQuantity()}
                  onChange={(e) => changeQuantity(e.target.value)}
                >
                  -
                </Button>

                <TextField
                  id="outlined-number"
                  type="tel"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    style: {
                      height: 32,
                      fontSize: 20,
                      width: 32,
                      padding: 0,
                      textAlign: "center",
                      fontSize: 17,
                      marginTop: 0,
                      fontWeight: "bold",
                      marginLeft: 17,
                      marginRight: 17,
                    },
                  }}
                  value={quantity}
                  variant="outlined"
                  padding={0}
                  disabled={true}
                  style={{
                    marginLeft: 15,
                    marginRight: 15,
                  }}
                  onChange={(e) => changeQuantity(e)}
                />

                {/* <Typography style={{fontSize:17,marginTop:2,fontWeight:'bold', marginLeft:15, marginRight:15}} variant='h6'>
                  {quantity}
              </Typography> */}

                <Button
                  style={{
                    height: 32,
                    fontSize: 20,
                    minWidth: 32,
                    border: "0.2px solid silver",
                  }}
                  onClick={increaseQuantity}
                >
                  +
                </Button>
              </div>

              {/* Add to cart and wishlist button */}
              <div
                style={{
                  paddingTop: 33,
                  display: "flex",
                  margin: "auto",
                }}
                className={classes.cartAndWishlistBtn}
              >
                <Button
                  onClick={addItemToCart}
                  className={classes.addToCartBtn}
                >
                  <AddShoppingCartIcon />
                  <Typography style={{ paddingLeft: 10 }}>
                    Add To Cart
                  </Typography>
                </Button>
                <Button
                  onClick={addItemToWishlist}
                  className={classes.addToWishlistBtn}
                >
                  <FavoriteBorderIcon />
                  <Typography style={{ paddingLeft: 10 }}>
                    Add To Wishlist
                  </Typography>
                </Button>
              </div>
            </Grid>

            {/* Delivery options section */}
            <Grid lg={3}>
              <div
                style={{
                  padding: 20,
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                }}
              >
                <Typography variant="p" style={{ fontWeight: "bold" }}>
                  Delivery options
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingTop: 15,
                  }}
                >
                  <DepartureBoardIcon style={{}} />
                  <div style={{ paddingLeft: 15 }}>
                    <Typography variant="p">Home Delivery</Typography>
                    <Typography style={{ color: "grey", fontSize: 13 }}>
                      4 - 6 days
                    </Typography>
                  </div>
                  <Typography
                    variant="p"
                    style={{
                      fontWeight: "bold",
                      marginLeft: "auto",
                      textAlign: "right",
                    }}
                  >
                    Rs.{" "}
                    {productDetails.shippingCost
                      ? productDetails.shippingCost
                      : 99}
                  </Typography>
                </div>
                <Typography
                  style={{ display: "flex", paddingTop: 15 }}
                  variant="p"
                >
                  <MonetizationOnIcon style={{ marginRight: 15 }} />
                  Cash on delivery Available
                </Typography>

                <Divider
                  style={{
                    backgroundColor: "#e9e9e9",
                    height: "0.1px",
                    marginTop: 15,
                    marginBottom: 15,
                  }}
                />

                <Typography variant="p" style={{ fontWeight: "bold" }}>
                  Return & Warranty
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingTop: 15,
                  }}
                >
                  <Filter7Icon style={{}} />
                  <div style={{ paddingLeft: 15 }}>
                    <Typography variant="p">7 Days Returns</Typography>
                    <Typography style={{ color: "grey", fontSize: 13 }}>
                      Change of mind is not applicable
                    </Typography>
                  </div>
                </div>

                <Typography
                  variant="p"
                  style={{ display: "flex", paddingTop: 15 }}
                >
                  <SecurityIcon style={{ marginRight: 15 }} />
                  {productDetails.warranty
                    ? `Warranty: ${productDetails.warranty}`
                    : `Warranty not available`}
                </Typography>

                <Divider
                  style={{
                    backgroundColor: "#e9e9e9",
                    height: "0.1px",
                    marginTop: 15,
                    marginBottom: 15,
                  }}
                />

                <div style={{ display: "flex" }}>
                  <div>
                    <Typography style={{ color: "grey", fontSize: 13 }}>
                      Sold By
                    </Typography>
                    <Typography variant="h6" style={{ fontWeight: "bold" }}>
                      {storeDetails
                        ? `${storeDetails.name} (${
                            storeDetails.city ? `${storeDetails.city}` : ""
                          })`
                        : ""}
                    </Typography>
                  </div>
                  <Button
                    variant="p"
                    className={classes.chatBtn}
                    style={{
                      marginLeft: "auto",
                      // backgroundColor: "transparent",
                      height: 35,
                      display: "flex",
                      color: "primary",
                      fontWeight: "bold",
                      textTransform: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <ForumIcon style={{ paddingLeft: 5 }} />
                    <Link
                      to={
                        token
                          ? `/buyer/messages?sellerId=${storeDetails.sellerId}`
                          : `/buyer/login`
                      }
                      style={{
                        color: "black",
                        textDecoration: "none",
                        padding: 8,
                      }}
                    >
                      Chat Now{" "}
                    </Link>
                  </Button>
                </div>

                <Button
                  className={classes.goToStoreBtn}
                  style={{ fontWeight: "bold" }}
                  onClick={() =>
                    history.push(`/store?storeId=${storeDetails._id}`)
                  }
                >
                  Go To Store
                </Button>
              </div>
            </Grid>
          </Grid>

          {/* Product description And Same Store Products box */}
          <Grid container lg={12} sm={12} md={12}>
            <Grid lg={9} sm={12} style={{ marginTop: 30 }}>
              <Box
                borderLeft={4}
                borderColor="primary.main"
                style={{
                  borderBottom: "0.2px solid #e9e9e9",
                  padding: 20,
                  paddingLeft: 26,
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: "bold",
                    textAlign: "justify",
                    textOverflow: "ellipsis",
                  }}
                >
                  Specifications of{" "}
                  {productDetails.name ? productDetails.name : "Product"}
                </Typography>
              </Box>
              <Box style={{ backgroundColor: "#fff", padding: 20 }}>
                {/* Product description in points Box*/}
                <div className={classes.specificationsBox}>
                  <div style={{ backgroundColor: "#fff" }}>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Category
                      </Typography>
                      <Typography>{productDetails.category}</Typography>
                    </div>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Sub-Category
                      </Typography>
                      <Typography>{productDetails.subCategory}</Typography>
                    </div>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Dimensions
                      </Typography>
                      <Typography>
                        {productDetails.dimensions
                          ? productDetails.dimensions
                              .split("X")
                              .map((dimension, index) =>
                                React.cloneElement(
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography>{` ${dimension}\t`}</Typography>
                                    <Typography
                                      variant="p"
                                      style={{
                                        fontWeight: "bold",
                                        padding: 4,
                                        paddingLeft: 12,
                                      }}
                                    >
                                      {index !==
                                      productDetails.dimensions.split("X")
                                        .length -
                                        1
                                        ? `\tX\t`
                                        : null}
                                    </Typography>
                                  </div>,

                                  {
                                    key: index,
                                  }
                                )
                              )
                          : null}
                      </Typography>
                    </div>
                  </div>

                  <div className={classes.midSpecifcationsBox}>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Warranty
                      </Typography>
                      <Typography>{productDetails.warranty}</Typography>
                    </div>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Color
                      </Typography>
                      <Typography style={{ whiteSpace: "nowrap" }}>
                        {productDetails.colors
                          ? productDetails.colors.join(", ")
                          : ""}
                      </Typography>
                    </div>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Size
                      </Typography>
                      <Typography>
                        {productDetails.dimensions
                          ? productDetails.dimensions
                          : ""}
                      </Typography>
                    </div>
                  </div>

                  <div className={classes.specificationLastBox}>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Brand
                      </Typography>
                      <Typography>
                        {productDetails.vendorCompanyName}
                      </Typography>
                    </div>
                    <div style={{ padding: 8 }}>
                      <Typography variant="p" style={{ color: "grey" }}>
                        Store Location
                      </Typography>
                      <Typography>{`${storeDetails.city}, ${storeDetails.country}`}</Typography>
                    </div>
                    <div style={{ padding: 8 }}>
                      <Typography
                        variant="p"
                        style={{ color: "grey", "word-spacing": "3px" }}
                      >
                        Stock Available
                      </Typography>
                      <Typography>{productDetails.stockAvailable}</Typography>
                    </div>
                  </div>
                </div>

                {/* Main Description in paragraph box */}
                <Grid lg={12} sm={12}>
                  <div
                    style={{
                      padding: 8,
                      paddingTop: 20,
                      paddingBottom: 20,
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: "bold",
                        textAlign: "justify",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Detailed Description of{" "}
                      {productDetails.name ? productDetails.name : "Product"}
                    </Typography>

                    <div style={{ paddingTop: 15 }}>
                      <Typography variant="p">
                        {productDetails.description}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Box>

              {/* Ratings and Reviews Box */}

              <Grid
                style={{
                  borderBottom: "0.2px solid #e9e9e9",
                  marginTop: 30,
                  backgroundColor: "#fff",
                }}
              >
                <Box
                  borderLeft={4}
                  borderColor="primary.main"
                  style={{
                    borderBottom: "0.2px solid #e9e9e9",
                    padding: 20,
                    paddingLeft: 26,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                      textAlign: "justify",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Ratings and Reviews of{" "}
                    {productDetails.name ? productDetails.name : "Product"}
                  </Typography>
                </Box>

                <Box style={{ backgroundColor: "#fff", padding: 22 }}>
                  {/* Avg Ratings Box */}
                  <div className={classes.AvgRatingsBoxes}>
                    <div>
                      <Typography
                        variant="h6"
                        style={{
                          padding: 6,
                          paddingBottom: 15,
                        }}
                      >
                        Average Rating
                      </Typography>
                      <Typography variant="h1" style={{ fontWeight: "bold" }}>
                        {productDetails.avgRating
                          ? productDetails.avgRating.toFixed(1)
                          : 0}
                        <span style={{ color: "grey", fontSize: 17 }}>
                          {" "}
                          / 5
                        </span>
                      </Typography>
                      <Rating
                        name="half-rating-read"
                        defaultValue={
                          productDetails.avgRating
                            ? productDetails.avgRating
                            : 0
                        }
                        //className={classes.ratingStars}
                        style={{ fontSize: 30, marginTop: 12 }}
                        precision={0.1}
                        readOnly
                      />
                      <Typography
                        style={{ color: "grey", fontSize: 14, marginLeft: 7 }}
                      >
                        {productDetails.totalRatingStars
                          ? Math.round(productDetails.totalRatingStars)
                          : 0}{" "}
                        Rating(s)
                      </Typography>
                    </div>

                    <div className={classes.numberedRatingsStarsBox}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          textAlign: "center",
                          justifyContent: "center",
                          margin: "auto",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <Typography variant="p" style={{ padding: 8 }}>
                            5 Stars
                          </Typography>
                          <div style={{ padding: 5 }}>
                            <Rating
                              name="half-rating-read"
                              defaultValue={5}
                              style={{ fontSize: 20 }}
                              //className={classes.ratingStars}
                              precision={0.5}
                              readOnly
                            />
                            <LinearProgress
                              variant="determinate"
                              style={{
                                backgroundColor: "#e9e9e9",
                              }}
                              value={fiveRatingCount * 10}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex" }}>
                          <Typography variant="p" style={{ padding: 8 }}>
                            4 Stars
                          </Typography>
                          <div style={{ padding: 5 }}>
                            <Rating
                              name="half-rating-read"
                              defaultValue={4}
                              style={{ fontSize: 20 }}
                              //className={classes.ratingStars}
                              precision={0.5}
                              readOnly
                            />
                            <LinearProgress
                              variant="determinate"
                              style={{
                                backgroundColor: "#e9e9e9",
                              }}
                              value={fourRatingCount * 10}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex" }}>
                          <Typography variant="p" style={{ padding: 8 }}>
                            3 Stars
                          </Typography>
                          <div style={{ padding: 5 }}>
                            <Rating
                              name="half-rating-read"
                              defaultValue={3}
                              style={{ fontSize: 20 }}
                              //className={classes.ratingStars}
                              precision={0.5}
                              readOnly
                            />
                            <LinearProgress
                              variant="determinate"
                              style={{
                                backgroundColor: "#e9e9e9",
                              }}
                              value={threeRatingCount * 10}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex" }}>
                          <Typography variant="p" style={{ padding: 8 }}>
                            2 Stars
                          </Typography>
                          <div style={{ padding: 5 }}>
                            <Rating
                              name="half-rating-read"
                              defaultValue={2}
                              style={{ fontSize: 20 }}
                              //className={classes.ratingStars}
                              precision={0.5}
                              readOnly
                            />
                            <LinearProgress
                              variant="determinate"
                              style={{
                                backgroundColor: "#e9e9e9",
                              }}
                              value={twoRatingCount * 10}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex" }}>
                          <Typography
                            variant="p"
                            style={{ padding: 8, paddingRight: 19 }}
                          >
                            1 Star
                          </Typography>
                          <div style={{ padding: 5 }}>
                            <Rating
                              name="half-rating-read"
                              defaultValue={1}
                              style={{ fontSize: 20 }}
                              //className={classes.ratingStars}
                              precision={0.5}
                              readOnly
                            />
                            <LinearProgress
                              variant="determinate"
                              style={{
                                backgroundColor: "#e9e9e9",
                              }}
                              value={oneRatingCount * 100}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Customer Reviews Box */}
                  <div style={{ paddingTop: 21 }}>
                    <div
                      style={{
                        paddingTop: 10,
                        paddingBottom: 10,
                      }}
                    >
                      <Typography variant="h6" style={{ fontWeight: "bold" }}>
                        Customer Reviews
                      </Typography>
                    </div>

                    {/* Cutomer Review and rating row div */}
                    {reviews.length > 0 ? (
                      reviews.map((review) =>
                        React.cloneElement(
                          <div
                            style={{
                              display: "flex",
                              paddingTop: 20,
                              paddingBottom: 20,
                              // borderTop: "0.2px solid #e9e9e9",
                              borderBottom: "0.2px solid #e9e9e9",
                            }}
                          >
                            <div>
                              <div
                                
                              >
                                <Rating
                                  name="half-rating-read"
                                  defaultValue={review.rating}
                                  style={{ fontSize: 20 }}
                                  //className={classes.ratingStars}
                                  precision={0.5}
                                  readOnly
                                />
                                <div className={classes.reviewVerificationAndTimeBox}>
                                  <Typography
                                    style={{
                                      color: "grey",
                                      fontSize: 13,
                                      maxWidth: 160,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    By {review.buyerName}
                                  </Typography>
                                  <div style={{display:'flex'}}>
                                    <VerifiedUserIcon
                                      style={{
                                        color: "#50B154",
                                        fontSize: 17,
                                        marginLeft: 5,
                                      }}
                                    />
                                    <Typography
                                      style={{ color: "#50B154", fontSize: 13 }}
                                    >
                                      Verified Purchase
                                    </Typography>
                                  </div>
                                </div>
                              </div>

                              <div
                                style={{
                                  paddingTop: 10,
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <Typography variant="p">
                                  {review.comment}
                                </Typography>
                                <Typography
                                  variant="p"
                                  style={{ fontStyle: "italic", marginTop: 5 }}
                                >
                                  <Reply
                                    style={{ fontSize: 14 }}
                                    color="primary"
                                  />
                                  {review.response
                                    ? `${
                                        review.storeName
                                          ? review.storeName
                                          : null
                                      } Replied: ${review.response}`
                                    : null}
                                </Typography>
                                <div style={{ display: "flex" }}>
                                  {review.pictures.map((picture) => {
                                    return (
                                      <img
                                        src={picture ? picture : noImage}
                                        style={{
                                          maxWidth: 100,
                                          maxHeight: 100,
                                          paddingTop: 10,
                                        }}
                                      />
                                    );
                                  })}
                                </div>
                              </div>
                              <div style={{ marginTop:5,fontWeight:'bold',  fontSize:13 }}>
                              {review.createdAt.split("T")[0]} ,{" "}
                              {review.createdAt.split("T")[1].split(":")[0]}:
                              {review.createdAt.split("T")[1].split(":")[1]}{" "}
                            </div>
                            </div>
                            
                          </div>,
                          {
                            key: review._id,
                          }
                        )
                      )
                    ) : (
                      <Typography>
                        No Reviews given yet, be the first to review.
                      </Typography>
                    )}
                  </div>
                  <Button
                    onClick={handleOpenReviewModal}
                    className={classes.addReviewBtn}
                  >
                    <Comment style={{marginRight:4}}/>
                    Add Review
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Related Products Of Store Box for Desktop */}
            <Grid
              style={{
                marginTop: 30,
                paddingLeft: 10,
                paddingRight: 10,
              }}
              className={classes.relatedStoreProductsDesktop}
              lg={3}
            >
              <Box
                borderLeft={4}
                borderColor="primary.main"
                className={classes.FromSameStoreHeadingBoxDesktop}
              >
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  From Same Store
                </Typography>
              </Box>
              <Grid  className={classes.fromSameStoreBox}
              >
                {topSellingProductsOfStore.map((item) =>
                  React.cloneElement(
                    <ProductCard
                      _id={item._id}
                      image={
                        Array.isArray(item.images)
                          ? item.images.length > 0
                            ? item.images[0]
                            : noImage
                          : item.images
                          ? item.images
                          : noImage
                      }
                      title={item.name}
                      cutPrice={item.discountPrice ? item.salePrice : null}
                      price={
                        item.discountPrice ? item.discountPrice : item.salePrice
                      }
                      category={item.category}
                      isNew={item.state === "new" ? true : false}
                      rating={item.avgRating}
                      discountPercentage={
                        item.discountPercentage ? item.discountPercentage : ""
                      }
                      storeName={item.storeName}
                      totalRatingStars={item.totalRatingStars}
                      brand={item.vendorCompanyName}
                      shippingCost={item.shippingCost}
                      stockAvailable={item.stockAvailable}
                      _id={item._id}
                    />,
                    {
                      key: item._id,
                    }
                  )
                )}
              </Grid>
            </Grid>
          </Grid>

          {/* For viewing store products on mobile in scroll view */}
          {/* Related Products Section */}
          <Grid className={classes.dealsBoxMobile} style={{ marginBottom: 25 }}>
            <Box className={classes.DealsHeaderTextBox}>
              <Box
                className={classes.DealsHeaderTextdiv}
                borderLeft={4}
                borderColor="primary.main"
              >
                <Typography
                  className={classes.dealsOfDayText}
                  variant="h3"
                  style={{ marginLeft: 13 }}
                >
                  From Same Store
                </Typography>
              </Box>

              <div className={classes.navDealProductsBtnBox}>
                <Button
                  onClick={() => scrollStoreProducts(-255)}
                  padding={0}
                  variant="contained"
                  marginRight={10}
                  style={{
                    padding: "0",
                    minWidth: "fit-content",
                  }}
                >
                  <ChevronLeftRoundedIcon />
                </Button>

                <Button
                  onClick={() => scrollStoreProducts(255)}
                  padding={0}
                  margin={0}
                  variant="contained"
                  style={{
                    padding: "0",
                    minWidth: "fit-content",
                    marginLeft: 14,
                  }}
                >
                  <ChevronRightOutlinedIcon />
                </Button>
              </div>
            </Box>
            <Divider style={{ marginTop: 12, marginBottom: 12 }} />

            {/* DEAL PRODUCTS CARDS */}
            <Grid ref={refStoreProducts} className={classes.DealProductsCardsScrollBox}>
            {topSellingProductsOfStore.map((item) =>
                  React.cloneElement(
                    <ProductCard
                      _id={item._id}
                      image={
                        Array.isArray(item.images)
                          ? item.images.length > 0
                            ? item.images[0]
                            : noImage
                          : item.images
                          ? item.images
                          : noImage
                      }
                      title={item.name}
                      cutPrice={item.discountPrice ? item.salePrice : null}
                      price={
                        item.discountPrice ? item.discountPrice : item.salePrice
                      }
                      category={item.category}
                      isNew={item.state === "new" ? true : false}
                      rating={item.avgRating}
                      discountPercentage={
                        item.discountPercentage ? item.discountPercentage : ""
                      }
                      storeName={item.storeName}
                      totalRatingStars={item.totalRatingStars}
                      brand={item.vendorCompanyName}
                      shippingCost={item.shippingCost}
                      stockAvailable={item.stockAvailable}
                      _id={item._id}
                    />,
                    {
                      key: item._id,
                    }
                  )
                )}
            </Grid>
          </Grid>

          {/* Related Products Section */}
          <Grid className={classes.dealsBox} style={{ marginBottom: 25 }}>
            <Box className={classes.DealsHeaderTextBox}>
              <Box
                className={classes.DealsHeaderTextdiv}
                borderLeft={4}
                borderColor="primary.main"
              >
                <Typography
                  className={classes.dealsOfDayText}
                  variant="h3"
                  style={{ marginLeft: 13 }}
                >
                  Related Products
                </Typography>
              </Box>

              <div className={classes.navDealProductsBtnBox}>
                <Button
                  onClick={() => scroll(-255)}
                  padding={0}
                  variant="contained"
                  marginRight={10}
                  style={{
                    padding: "0",
                    minWidth: "fit-content",
                  }}
                >
                  <ChevronLeftRoundedIcon />
                </Button>

                <Button
                  onClick={() => scroll(255)}
                  padding={0}
                  margin={0}
                  variant="contained"
                  style={{
                    padding: "0",
                    minWidth: "fit-content",
                    marginLeft: 14,
                  }}
                >
                  <ChevronRightOutlinedIcon />
                </Button>
              </div>
            </Box>
            <Divider style={{ marginTop: 12, marginBottom: 12 }} />

            {/* DEAL PRODUCTS CARDS */}
            <Grid ref={ref} className={classes.DealProductsCardsScrollBox}>
              {relatedProducts.map((item) =>
                React.cloneElement(
                  <ProductCard
                    _id={item._id}
                    image={
                      Array.isArray(item.images)
                        ? item.images.length > 0
                          ? item.images[0]
                          : noImage
                        : item.images
                        ? item.images
                        : noImage
                    }
                    title={item.name}
                    cutPrice={item.discountPrice ? item.salePrice : null}
                    price={
                      item.discountPrice ? item.discountPrice : item.salePrice
                    }
                    category={item.category}
                    isNew={item.state === "new" ? true : false}
                    rating={item.avgRating}
                    discountPercentage={
                      item.discountPercentage
                        ? item.discountPercentage + "%"
                        : ""
                    }
                    storeName={item.storeName}
                    totalRatingStars={item.totalRatingStars}
                    brand={item.vendorCompanyName}
                    shippingCost={item.shippingCost}
                    stockAvailable={item.stockAvailable}
                    _id={item._id}
                  />,
                  {
                    key: item._id,
                  }
                )
              )}
            </Grid>
          </Grid>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="p" style={{ paddingRight: 5 }}>
            Loading
          </Typography>
          <img className={classes.loadingImgDiv} src={loadingImg}></img>
        </div>
      )}

      {/* Add Review Modal */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Modal
          className={classes.modal}
          open={openReviewModal}
          onClose={handleCloseReviewModal}
          closeAfterTransition
          style={{
            width: "100%",
            // maxWidth: "100vw",
            maxHeight: "100%",
            position: "fixed",
            top: "2%",
            // right: "18%",
            left:'0%',
            alignItems:'center',
            display:'flex',
            justifyContent:'center'
          }}
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Grid container style={{display:'flex',justifyContent:'center'}} className={classes.root}>
            <Grid
              className={classes.mainGrid}
              style={{ padding: 30 }}
              item
              xs={12}
              sm={11}
              md={8}
              component={Paper}
              elevation={6}
              square
            >
              <div className={classes.paper}>
                <Typography
                  variant="h5"
                  style={{ fontWeight: "bold", marginBottom: 10 }}
                >
                  Add Review of{" "}
                  {productDetails ? productDetails.name : "product"}
                </Typography>
                <div className={classes.form}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingBottom: 10,
                    }}
                  >
                    <Typography variant="p" style={{ color: "#666" }}>
                      Rating
                    </Typography>
                    <div style={{ display: "flex" }}>
                      <Rating
                        name="simple-controlled"
                        value={newReview.rating}
                        precision={0.5}
                        onChange={(event, newValue) => {
                          setNewReview({ ...newReview, rating: newValue });
                        }}
                      />
                      <Typography>({newReview.rating})</Typography>
                    </div>
                  </div>
                  <Typography
                    variant="p"
                    style={{ marginTop: 16, color: "#666" }}
                  >
                    Review Description
                  </Typography>
                  <TextField
                    id="reviewDescription"
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="review"
                    label="Review Description"
                    type="text"
                    multiline
                    rows={3}
                    color="primary"
                    style={{ marginTop: 8 }}
                    onChange={(e) =>
                      setNewReview({ ...newReview, comment: e.target.value })
                    }
                  />

                  <Typography
                    variant="p"
                    style={{ marginTop: 10, color: "#666" }}
                  >
                    Product Images
                  </Typography>
                  <InputLabel
                    style={{
                      color: "red",
                      textAlign: "center",
                    }}
                  >
                    {/* {loginData.errorMessage.toString()} */}
                  </InputLabel>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: 10,
                      marginBottom: 5,
                      padding: 20,
                      height: 120,
                      border: "1px solid #c4c4c4",
                      borderRadius: 6,
                    }}
                  >
                    <Grid container justify="center" spacing={2}>
                      {newReview.pictures ? (
                        newReview.pictures.length > 0 ? (
                          newReview.pictures.map((img, index) => (
                            <Grid item key={index} align="center">
                              <img
                                src={img}
                                alt="product-images"
                                width="60px"
                                height="60px"
                                style={{
                                  border: "3px solid #e1e1e1",
                                  padding: "2px",
                                }}
                              />
                              <div>
                                <HighlightOffRoundedIcon
                                  onClick={() => handlerDeletePImage(index)}
                                  style={{
                                    color: "grey",
                                  }}
                                />
                              </div>
                            </Grid>
                          ))
                        ) : null
                      ) : (
                        <Typography>Upload Product Images</Typography>
                      )}
                    </Grid>
                  </div>

                  <Grid item style={{ marginBottom: 20 }}>
                    <div>
                      <label htmlFor="contained-button-file">
                        <Button
                          size="small"
                          startIcon={<AddPhotoAlternateIcon />}
                          variant="outlined"
                          color="primary"
                          component="span"
                        >
                          Upload Images
                        </Button>
                      </label>
                      <input
                        id="contained-button-file"
                        type="file"
                        multiple
                        accept="image/png, image/jpeg"
                        onChange={fileHandler}
                        hidden
                      />
                    </div>
                    <Typography variant="p" style={{ color: "red" }}>
                      {addReviewErrorMsg}
                    </Typography>
                  </Grid>

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => handleAddingReview()}
                  >
                    Submit
                  </Button>
                  <Button
                    type="submit"
                    fullWidth
                    style={{ backgroundColor: "#e5e5e5", marginTop: 10 }}
                    className={classes.submit}
                    onClick={handleCloseReviewModal}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Modal>
      </div>
    </div>
  );
}
